import { useEffect, useState } from 'react';
import { EmployeeApi, EmployeeDto } from '../http';

interface Options {
  uuid: string;
  onSuccess?: (values: any) => void;
  onError?: (error: any) => void;
}

export const useEmployeeDetail = ({ uuid }: Options) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [data, setData] = useState<EmployeeDto>();
  const employeeApi = new EmployeeApi();

  useEffect(() => {
    setIsLoading(true);
    employeeApi
      .findOne(uuid)
      .then((response: EmployeeDto) => {
        setData(response);
        setIsLoading(false);
      })
      .catch((e) => {
        setErrors(e.errorMessage);
      });
  }, []);

  return {
    data,
    isLoading,
    errors
  };
};
